import { ApiProperty } from "@nestjs/swagger";

export class CycleCheckerDateRequest {
    @ApiProperty()
    fromDate: Date;
    @ApiProperty()
    toDate: Date
    @ApiProperty()
    createdAt?:Date
}

export class ItemIdRequest{
    @ApiProperty()
    itemId:number;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    locationId?:number;
   
}